import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

export function calculateRemainingShelfLife(manufacturingDate?: string, expirationDate?: string): number {
  if (!manufacturingDate || !expirationDate) {
    return 0
  }

  const mfgDate = dayjs.utc(manufacturingDate)
  const expDate = dayjs.utc(expirationDate)
  const currentDate = dayjs.utc()

  if (currentDate.isAfter(expDate)) {
    return 0
  }

  if (currentDate.isBefore(mfgDate)) {
    return 100
  }

  const totalShelfLife = expDate.diff(mfgDate, "day")

  if (totalShelfLife === 0) {
    return 0
  }

  const remainingDays = expDate.diff(currentDate, "day")
  const percentage = Math.round((remainingDays / totalShelfLife) * 100)

  return Math.max(0, Math.min(100, percentage))
}
